import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import SingleSpecificPpvMobile from '../../MobileComponents/Ppv/SingleSpecificPpvMobile';
import SpecificPpvYearInfo from '../../../pages/SpecificPpvYearInfo';

const SpecificPpvResponsive = () => {
    const { isMobile } = useResponsiveRedux();
    return isMobile ? <SingleSpecificPpvMobile /> : <SpecificPpvYearInfo />;
};

export default SpecificPpvResponsive; 